// src/tooltip.dom.ts
import { createScope, getScrollParent } from "@zag-js/dom-query";
var dom = createScope({
  getTriggerId: (ctx) => ctx.ids?.trigger ?? `tooltip:${ctx.id}:trigger`,
  getContentId: (ctx) => ctx.ids?.content ?? `tooltip:${ctx.id}:content`,
  getArrowId: (ctx) => `tooltip:${ctx.id}:arrow`,
  getPositionerId: (ctx) => `tooltip:${ctx.id}:popper`,
  getTriggerEl: (ctx) => dom.getById(ctx, dom.getTriggerId(ctx)),
  getContentEl: (ctx) => dom.getById(ctx, dom.getContentId(ctx)),
  getPositionerEl: (ctx) => dom.getById(ctx, dom.getPositionerId(ctx)),
  getArrowEl: (ctx) => dom.getById(ctx, dom.getArrowId(ctx)),
  getScrollParent: (ctx) => getScrollParent(dom.getTriggerEl(ctx))
});

export {
  dom
};
